module.exports = "<div class=\"roles-manager\">\n    <div class=\"roles-container\">\n        <dbm-list [listTitle]=\"'Role Management'\" [listAction]=\"'Add Role'\" [listSearchPlaceholder]=\"'Search Role'\"\n            [listItems]=\"roles\" (onActionClick)=\"addRole()\" (onListItemClick)=\"getRole($event.selectedItem, $event.indexInList)\"></dbm-list>\n    </div>\n    <role [role]=\"role\" (onDuplicate)=\"duplicateRole()\" (onDelete)=\"deleteRole()\"></role>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/usersRolesManagement/roles-management/roles-management.component.html
// module id = 1859
// module chunks = 0